<template>
  <v-dialog :value="value" :retain-focus="false" persistent max-width="560" @input="$emit('input', $event)">
    <v-card>
      <v-card-title>{{ $t("bookings.deposit_hold.withhold") }}</v-card-title>
      <v-card-text>
        <v-select v-model="form.category" :items="categories" item-text="text" item-value="value"
          :label="$t('bookings.deposit_hold.category')"></v-select>
        <v-text-field v-model.trim="form.reason" :label="$t('bookings.deposit_hold.reason')"></v-text-field>
        <v-text-field v-model.number="form.sum" type="number" min="0" :label="$t('custom.amount')"></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text :disabled="loading" @click="$emit('input', false)">{{ $t("custom.cancel") }}</v-btn>
        <v-btn color="primary" :loading="loading" :disabled="!valid || loading" @click="$emit('submit', { ...form })">
          {{ $t("bookings.deposit_hold.withhold") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DepositWithholdDialog",
  props: { value: Boolean, loading: Boolean },
  data() { return { form: { category: "other", reason: "", sum: null } }; },
  computed: {
    categories() {
      return ["clean", "gas", "damage", "mileage", "other"].map((value) => ({
        value, text: this.$t(`bookings.deposit_hold.categories.${value}`),
      }));
    },
    valid() { return !!(this.form.category && this.form.reason.trim() && Number(this.form.sum) > 0); },
  },
  watch: { value(open) { if (open) this.form = { category: "other", reason: "", sum: null }; } },
};
</script>
